import i18n from '@wix/wix-vod-shared/src/common/i18n';

import VIEW_MODES from 'shared/constants/view-modes';

import WixSDK from 'shared/utils/wix-sdk';
import { openModal, closeModal, closeCatcher } from 'shared/components/modal/modal';
import { PrimaryButton } from 'shared/components/button/button';

import styles from './preview-prompt.styl';

import translations from 'messages/widget';


const PreviewModePrompt = () => (
  <div className={styles['prompt-wrapper']}
       data-hook="preview-mode-prompt">
    <div>
      {i18n.t(translations.youInPreview1)}
    </div>

    <div className={styles['second-message']}>
      {i18n.t(translations.youInPreview2)}
    </div>

    <PrimaryButton dataHook="close-preview-prompt"
                   className={styles['close-button']}
                   onClick={closeModal}>
      {i18n.t(translations.previewGotIt)}
    </PrimaryButton>
  </div>
);

export function isPreviewOrEditorMode() {
  return _.includes([VIEW_MODES.PREVIEW, VIEW_MODES.EDITOR], WixSDK.Utils.getViewMode());
}

export function openPreviewPrompt() {
  openModal({
    contentClassName: styles['modal-content'],
    className: styles.modal,
    closeOnOverlayClick: true,
    title: i18n.t(translations.previewMode),
    content: <PreviewModePrompt />,
  })
    .catch(closeCatcher);
}



// WEBPACK FOOTER //
// ./src/widget/components/preview-prompt/preview-prompt.js